@if (session(); as active) {
  <div class="c-impersonation-banner" role="status" *transloco="let t; prefix: 'users.impersonation'">
    <div class="c-impersonation-banner__text">
      <div>
        {{ t('banner.active', { user: active.displayName ?? active.email }) }}
      </div>
      <div class="c-impersonation-banner__meta">
        {{ active.email }} · {{ userTypeLabel() }}
      </div>
    </div>
    <aml-button [variant]="ButtonVariantMap.secondary" [size]="ButtonSizeMap.sm" (click)="onSwitchBack()">
      {{ t('actions.switchBack') }}
    </aml-button>
  </div>
}
